import { tscope } from '@i18n/index';
import React from 'react';
import {
  Text,
  Modal,
  Button,
  ModalBody,
  ModalHeader,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  UnorderedList,
  Divider,
} from 'ui';
import { style as s } from './ClabeModal.style';

export const ts = tscope('Documents.CLABE.modal');

export const ClabeModal = (props) => {
  const {
    onClose, isOpen,
  } = props;

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent data-testid="modalContent">
        <ModalCloseButton data-testid="closeButton" />
        <ModalHeader {...s.header}>{ts('title')}</ModalHeader>
        <Divider />
        <ModalBody {...s.body}>
          <Text>
            {ts('body1')}
          </Text>
          <Text>
            {ts('body2')}
          </Text>
          <UnorderedList {...s.ul}>
            {ts('list').map((item) => (
              <li key={item}>
                {item}
              </li>
            ))}
          </UnorderedList>
          <Button onClick={onClose} {...s.button}>
            {ts('gotIt')}
          </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
